import React, { FC } from 'react';
import { Link } from '../../Link';
import styled from '@emotion/styled';
import Pdf from '~/icons/pdf.svg';
import { theme } from '~/theme';

const Wrapper = styled.div(() => ({
    display: 'flex',
    svg: {
        marginRight: '10px',
        height: '35px',
        width: '35px',
    },
}));

export type Props = {
    productDocumentation: [Path: string, Name: string];
};

export const ProductDocumentation: FC<Props> = ({ productDocumentation }) => (
    <Wrapper css={{ textAlign: 'left' }}>
        <ul>
            {productDocumentation.map((link: any) => (
                <li style={{ padding: '5px 0' }}>
                    <Link color={theme.colors.black} href={link.Path} target="_blank">
                        <Pdf />
                        <span css={{ textTransform: 'capitalize', fontSize: '14px' }}>
                            {link.Name}
                        </span>
                    </Link>
                </li>
            ))}
        </ul>
    </Wrapper>
);
